import { Component, Input } from '@angular/core';
import { DetailPanelComponent } from '../../../core/panels/detail-panel/detail-panel.component';
import { DetailItemComponent } from '../../../core/panels/detail-panel/detail-item.component';
import { AllocationDetails } from '../../../../models/api/view/claim/financials/payment-history/payment-allocation-details';

@Component({
  selector: 'app-escheatment-detail',
  imports: [DetailPanelComponent, DetailItemComponent],
  template: `
    <div class="tw-flex tw-gap-4 tw-pb-4">
      <div class="tw-flex tw-gap-8">
        <div class="">
          <app-detail-panel [dataSource]="allocationDetails">
            <app-detail-item label="Check status" name="checkStatus" />
            <app-detail-item
              label="Check status date"
              name="checkStatusDate"
              format="d"
            />
            <app-detail-item
              label="State for escheatment"
              name="escheatState"
            />
            <app-detail-item
              label="Date escheated to state"
              name="dateEscheatState"
              format="d"
            />
          </app-detail-panel>
        </div>
      </div>
    </div>
  `,
  styles: [],
})
export class EscheatmentDetailComponent {
  @Input() allocationDetails: AllocationDetails | null = null;
}
